import { FeatureWrap, RegularSelectInput, TextInput } from "components/core";

import { CreateEmployeeAccountVariables } from "_graphql/mutation/__generated__/CreateEmployeeAccount";
import { FC } from "react";
import { FormikProps } from "formik";
import { Permissions } from "_graphql/data";
import RolePicker from "components/core/role-picker";

export interface EmployeeFormProps {
    form: FormikProps<CreateEmployeeAccountVariables["employee"]>;
}

const EmployeeForm: FC<EmployeeFormProps> = ({ form }) => {
    return (
        <div className="space-y-6 divide-y divide-gray-200">
            <div>
                <span className="text-xs font-light">Employee Information</span>
                <div className="grid grid-cols-2 gap-2">
                    <div>
                        <TextInput
                            id="employee_first_name"
                            label="First Name"
                            type="text"
                            placeholder="e.g. Emmanuel"
                            required={true}
                            {...form}
                        />
                    </div>

                    <div className="space-y-1 ">
                        <TextInput
                            id="employee_last_name"
                            label="Last Name"
                            type="text"
                            placeholder="e.g. Baidoo"
                            required={true}
                            {...form}
                        />
                    </div>
                    <div>
                        <TextInput
                            id="employee_email"
                            label="Email"
                            type="text"
                            placeholder="e.g. ebaidoo79@gmail.com"
                            required={true}
                            {...form}
                        />
                    </div>

                    <div className="space-y-1 ">
                        <TextInput
                            id="employee_phonenumber"
                            label="Phone Number"
                            type="text"
                            placeholder="e.g. 0506339153"
                            required={true}
                            {...form}
                        />
                    </div>
                    <FeatureWrap domains={["Visal"]}>
                        <div className="space-y-1 col-span-2 ">
                            <RegularSelectInput
                                id="employee_position"
                                label="Position"
                                placeholder="e.g. 0506339153"
                                options={[
                                    ...Permissions.map(({ name, value }) => ({ label: name, value })),
                                ]}
                                required={true}
                                {...form}
                            />
                        </div>
                    </FeatureWrap>
                    <FeatureWrap domains={["KEK"]}>
                        <div className="space-y-1 col-span-2 ">
                            <RolePicker
                                id="user_role_id"
                                label="Position"
                                placeholder="e.g. System Admin"
                                required={true}
                                // rawId
                                {...form}
                            />
                        </div>
                    </FeatureWrap>
                </div>
            </div>
        </div>
    );
};

export default EmployeeForm;
